import React, { createContext, useContext, useState } from 'react';

interface ContextProps {
    query: string;
    setQuery: (arg: any) => void;
}

const defaultState = {
    query: '',
    setQuery: (q: string) => {},
};

const QueryContext = createContext<ContextProps>(defaultState);

export const QueryContextProvider: React.FC = ({ children }) => {
    const context = useProvideQueryContext();

    return <QueryContext.Provider value={context}>{children}</QueryContext.Provider>;
};

export const useQueryContext = () => {
    return useContext(QueryContext);
};

function useProvideQueryContext() {
    const [query, setQuery] = useState<ContextProps['query']>(defaultState.query);
    return {
        query,
        setQuery
    };
}
